export default "__VITE_ASSET__ade26bf6__"